import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/redux/rootState';
import PropertyManager from '../../utils/propertyManager';
import { ensureUserAccessLoaded } from '../../utils/appDataLoader';

const useGetPermission = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector((state: RootState) => state.user);
  const permissions = useSelector((state: RootState) => state.permissions);
  const menu = useSelector((state: RootState) => state.menu);

  useEffect(() => {
    void ensureUserAccessLoaded(dispatch, currentUser, menu, permissions);
  }, [currentUser, dispatch, menu, permissions]);

  try {
    if (permissions && PropertyManager.isDefined(permissions) && permissions.length > 0) {
      return permissions;
    }
  } catch (error) {
    console.error('useGetPermission failed:', error);
  }
  return [];
};

export default useGetPermission;
